export default __webpack_public_path__ + "static/media/DSC06047.853e9548.jpg";